import './Home.component.scss';

import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { ERoutes } from '../../../assets/constants/routes';
import contacts from '../../../assets/icons/CONTACTOS_azul.svg';
import personal from '../../../assets/icons/DATOSPERSONALES_azul.svg';
import yellowDecor from '../../../assets/icons/ELEMENTOS_DECO.svg';
import groups from '../../../assets/icons/GRUPOS_azul.svg';
import liliHome from '../../../assets/icons/LILI_HOME.svg';
import wishlist from '../../../assets/icons/LISTADESEOS_azul.svg';
import account from '../../../assets/icons/MICUENTA_azul.svg';
import present from '../../../assets/icons/REGALO_MAGICO.svg';
import { makeSelectCurrentUser } from '../../../store/current-user/current-user.selectors';
import { CardComponent } from '../../atoms/atoms.index';
import { NavbarComponent } from '../../organisms/organisms.index';
import { Link } from 'react-router-dom';

export function HomeComponent() {
  const currentUser = useSelector(makeSelectCurrentUser());
  const [userIsChecked, setUserIsChecked] = useState(false);

  useEffect(() => {
    if (
      !!currentUser &&
      currentUser.isOfLegalAge &&
      currentUser.legalConditionsAccepted
    ) {
      setUserIsChecked(true);
    }
  }, [currentUser]);

  const listItems = [
    {
      img: wishlist,
      path: ERoutes.WISH_LIST_CATALOGUE,
      title: (
        <FormattedMessage id='pages.home.wishlist'>
          {txt => txt}
        </FormattedMessage>
      ),
    },
    {
      img: groups,
      path: ERoutes.GROUP_LIST,
      title: (
        <FormattedMessage id='pages.home.groups'>{txt => txt}</FormattedMessage>
      ),
    },
    {
      img: contacts,
      path: ERoutes.MY_CONTACT_LIST,
      title: (
        <FormattedMessage id='pages.home.contacts'>
          {txt => txt}
        </FormattedMessage>
      ),
    },
    {
      img: account,
      path: ERoutes.MY_BANK,
      title: (
        <FormattedMessage id='pages.home.my-bank'>
          {txt => txt}
        </FormattedMessage>
      ),
    },
    {
      img: personal,
      path: ERoutes.PERSONAL_PAGE,
      title: (
        <FormattedMessage id='pages.home.personal'>
          {txt => txt}
        </FormattedMessage>
      ),
    },
  ];
  return (
    <div className='home-page'>
      {userIsChecked ? (
        <div>
          <NavbarComponent
            showName={true}
            showLogout={true}
            showHelp={true}
            hideBack={true}
          />

          <section className='home-header d-flex flex-row flex-nowrap justify-content-start align-items-center'>
            <div className='home-header-text'>
              <FormattedMessage id='pages.home.title' />
              <div className='home-wish-find'>
                <FormattedMessage id='pages.home.search-wish-title' />
                <Link to={ERoutes.WISH_FINDER}>
                  <FormattedMessage id='pages.home.click-here' />
                </Link>
              </div>
            </div>
            <img className='home-header-picture' src={liliHome} alt='' />
          </section>
          <section className='home-menu d-flex justify-content-around align-items-center mt-2 mt-sm-4'>
            <div className='home-list-container'>
              {listItems.map((item, idx) => (
                <CardComponent
                  class={`home-menu-item-${idx + 1}`}
                  key={`home-menu-item-${idx + 1}`}
                  {...item}
                />
              ))}
            </div>
          </section>

          <div className='home-banner-container'>
            <article className='home-banner d-flex flex-row flex-nowrap justify-content-between align-items-center ml-5'>
              <section className='home-banner-left d-flex flex-row flex-nowrap align-items-center'>
                <img className='home-image-deco' src={yellowDecor} alt='' />
                <div className='banner-text'>
                  <FormattedMessage id='pages.home.banner' />
                </div>
              </section>
              <section className='home-banner-right'>
                <img className='home-image-present' src={present} alt='' />
              </section>
            </article>
          </div>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}
